import React from 'react'
import SocialLogin from 'react-social-login'
 
const SButton = ({ google, triggerLogin, ...props }) => (
    <a onClick={triggerLogin} {...props} className={`loginbtn ${google ? 'signup-googlebig' : ''}`.trim()}>
        <i className={`fab m-r-5 fa-${google ? 'google-plus-g' : 'facebook'}`}></i> 
        <span>{google ? "Google" : "Facebook"}</span>
    </a>
)

const SocialButton = SocialLogin(SButton);

export default SocialButton;